module.exports = __webpack_public_path__ + "static/media/step-one-big.7a1a7850.webp";